module.exports = __webpack_public_path__ + "img/21-consultas-alvaras-vencer-lista.ec1d6cd3.png";